//import React, { useEffect, useState } from 'react';
//import Loading from "../../../component/Loading/Loading";
//import { useSelector } from "react-redux";
//import useAxiosInstance from '../../../services/useAxiosInstance';
//import { AlertTriangle, FileText } from 'lucide-react';

//const DashboardViolation = () => {
//  const axiosInstance = useAxiosInstance();
//  const [violations, setViolations] = useState([]);
//  const [clients, setClients] = useState({});
//  const [statusMap, setStatusMap] = useState({});
//  const [loading, setLoading] = useState(false);
//  const communityId = useSelector((state) => state.auth.communityId);
//  const userId = useSelector((state) => state.auth.userId);
//  const roleId = useSelector((state) => state.auth.roleId);
//  const clientIds = useSelector((state) => state.auth.clientId);

//  const communityIdget = communityId;

//  let clientIdget;
//  if (roleId === 1001 || roleId === 1002) {
//    clientIdget = 0;
//  } else if (roleId === 1003) {
//    clientIdget = clientIds;
//  }

//  useEffect(() => {
//    const fetchViolations = async () => {
//      setLoading(true);
//      try {
//        const response = await axiosInstance.get(`/api/violation/CommunityIdAndCreatedById`, {
//          params: {
//            communityId: communityIdget,
//            clientId: clientIdget,
//          }
//        });
//        setViolations(response.data);
//      } catch (error) {
//        console.error('Error fetching violations:', error);
//      } finally {
//        setLoading(false);
//      }
//    };

//    const fetchClients = async () => {
//      try {
//        const response = await axiosInstance.get(`/api/public/client/getAll`);
//        const clientMap = response.data.reduce((acc, client) => {
//          acc[client.clientid] = client;
//          return acc;
//        }, {});
//        setClients(clientMap);
//      } catch (error) {
//        console.error('Error fetching clients:', error);
//      }
//    };

//    const fetchStatus = async () => {
//      try {
//        const response = await axiosInstance.get(`/api/violationStatus/getAll`);
//        const statusMap = response.data.reduce((acc, status) => {
//          acc[status.violationStatusId] = status.violationStatus;
//          return acc;
//        }, {});
//        setStatusMap(statusMap);
//      } catch (error) {
//        console.error('Error fetching status:', error);
//      }
//    };

//    fetchViolations();
//    fetchClients();
//    fetchStatus();
//  }, []);

//  const filteredViolations = violations.filter(item => {
//    const violationDate = new Date(item.violationDate);
//    const currentDate = new Date();

//    const sevenDaysAgo = new Date();
//    sevenDaysAgo.setDate(currentDate.getDate() - 7);

//    return violationDate >= sevenDaysAgo && violationDate <= currentDate;
//  });

//  const getStatusClass = (status) => {
//    switch (status) {
//      case 'Completed':
//        return 'text-green-600';
//      case 'In Progress':
//        return 'text-blue-600';
//      case 'Cancelled':
//        return 'text-gray-600';
//      case 'Submitted':
//        return 'text-purple-600';
//      default:
//        return 'text-gray-700';
//    }
//  };

//  return (
//    <div className="bg-gray-50 md:p-4">
//      {loading && <Loading />}
//      {!loading && (
//        <div className="max-w-7xl mx-auto">
//          <div className="flex justify-between items-center mb-6">
//            <div>
//              <h1 className="text-2xl font-bold text-gray-800">Recent Violations</h1>
//              <p className="text-sm text-gray-500">Showing violations from the last 7 days</p>
//            </div>
//            <div className="bg-blue-50 text-blue-600 px-3 py-1 rounded-md items-center hidden md:flex">
//              <FileText size={16} className="mr-2" />
//              <span>{filteredViolations.length} violations</span>
//            </div>
//          </div>

//          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//            <div className="overflow-x-auto">
//              <table className="min-w-full divide-y divide-gray-200">
//                <thead className="bg-blue-400">
//                  <tr>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Name</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Date</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amount</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Status</th>
//                  </tr>
//                </thead>
//                <tbody className="bg-white divide-y divide-gray-200">
//                  {filteredViolations.length === 0 ? (
//                    <tr>
//                      <td colSpan="5" className="px-6 py-8 text-center">
//                        <div className="flex flex-col items-center justify-center text-gray-500">
//                          <AlertTriangle size={24} className="mb-2" />
//                          <p>No violations found in the last 7 days</p>
//                        </div>
//                      </td>
//                    </tr>
//                  ) : (
//                    filteredViolations.map((violation) => {
//                      const client = clients[violation.clientId] || {};
//                      const status = statusMap[violation.violationStatusId] || 'Unknown';
//                      return (
//                        <tr key={violation.violationId} className="hover:bg-gray-50">
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{client.displayname || 'N/A'}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(violation.violationDate).toLocaleDateString()}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${violation.amount.toFixed(2)}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                            <span className={`px-2 py-1 rounded-full text-xs ${getStatusClass(status)}`}>
//                              {status}
//                            </span>
//                          </td>
//                        </tr>
//                      );
//                    })
//                  )}
//                </tbody>
//              </table>
//            </div>
//          </div>
//        </div>
//      )}
//    </div>
//  );
//};

//export default DashboardViolation;

import React, { useEffect, useState } from 'react';
import Loading from "../../../component/Loading/Loading";
import { useSelector } from "react-redux";
import useAxiosInstance from '../../../services/useAxiosInstance';
import { AlertTriangle, FileText } from 'lucide-react';

const DashboardViolation = () => {
    const axiosInstance = useAxiosInstance();
    const [violations, setViolations] = useState([]);
    const [clients, setClients] = useState({});
    const [statusMap, setStatusMap] = useState({});
    const [loading, setLoading] = useState(false);

    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const roleId = useSelector((state) => state.auth.roleId);
    const clientIds = useSelector((state) => state.auth.clientId);

    // Role-based parameter configuration
    const getApiParameters = () => {
        let communityIdParam, clientIdParam;

        switch (roleId) {
            case 1000: // Superadmin - All communities
                communityIdParam = 0;
                clientIdParam = 0;
                break;
            case 1001: // HOA Admin - Specific community, all clients
            case 1002: // Board Member - Specific community, all clients
                communityIdParam = communityId;
                clientIdParam = 0;
                break;
            case 1003: // User - Specific community and client
                communityIdParam = communityId;
                clientIdParam = clientIds;
                break;
            default:
                communityIdParam = communityId;
                clientIdParam = 0;
        }

        return { communityIdParam, clientIdParam };
    };

    useEffect(() => {
        const fetchViolations = async () => {
            setLoading(true);
            try {
                const { communityIdParam, clientIdParam } = getApiParameters();

                // Different endpoint for superadmin vs community-specific
                const endpoint = roleId === 1000
                    ? `/api/violation/admin/getAllViolations` // All communities
                    : `/api/violation/CommunityIdAndCreatedById`;

                const response = await axiosInstance.get(endpoint, {
                    params: {
                        communityId: communityIdParam,
                        clientId: clientIdParam,
                        ...(roleId === 1000 && { includeAllCommunities: true })
                    }
                });

                setViolations(response.data);
            } catch (error) {
                console.error('Error fetching violations:', error);

                // Fallback data based on role
                setFallbackData();
            } finally {
                setLoading(false);
            }
        };

        const fetchClients = async () => {
            try {
                const response = await axiosInstance.get(`/api/public/client/getAll`);
                const clientMap = response.data.reduce((acc, client) => {
                    acc[client.clientid] = client;
                    return acc;
                }, {});
                setClients(clientMap);
            } catch (error) {
                console.error('Error fetching clients:', error);

                // Fallback client data
                setClients({
                    1: { displayname: 'John Smith', communityName: 'Oak Hills' },
                    2: { displayname: 'Sarah Johnson', communityName: 'Pine Valley' },
                    3: { displayname: 'Mike Davis', communityName: 'Maple Gardens' },
                    4: { displayname: 'Lisa Wilson', communityName: 'Cedar Ridge' }
                });
            }
        };

        const fetchStatus = async () => {
            try {
                const response = await axiosInstance.get(`/api/violationStatus/getAll`);
                const statusMap = response.data.reduce((acc, status) => {
                    acc[status.violationStatusId] = status.violationStatus;
                    return acc;
                }, {});
                setStatusMap(statusMap);
            } catch (error) {
                console.error('Error fetching status:', error);

                // Fallback status data
                setStatusMap({
                    1: 'Submitted',
                    2: 'In Progress',
                    3: 'Completed',
                    4: 'Cancelled'
                });
            }
        };

        fetchViolations();
        fetchClients();
        fetchStatus();
    }, [roleId, communityId, clientIds]);

    // Fallback data based on role
    const setFallbackData = () => {
        const currentDate = new Date();
        const getRandomDate = (daysAgo) => {
            const date = new Date(currentDate);
            date.setDate(currentDate.getDate() - daysAgo);
            return date.toISOString();
        };

        if (roleId === 1000) {
            // Superadmin - More violations across multiple communities
            setViolations([
                {
                    violationId: 1,
                    clientId: 1,
                    violationDate: getRandomDate(1),
                    amount: 150.00,
                    violationStatusId: 2,
                    violationType: 'Parking Violation',
                    communityId: 101
                },
                {
                    violationId: 2,
                    clientId: 2,
                    violationDate: getRandomDate(2),
                    amount: 75.00,
                    violationStatusId: 1,
                    violationType: 'Noise Complaint',
                    communityId: 102
                },
                {
                    violationId: 3,
                    clientId: 3,
                    violationDate: getRandomDate(3),
                    amount: 200.00,
                    violationStatusId: 3,
                    violationType: 'Property Maintenance',
                    communityId: 103
                },
                {
                    violationId: 4,
                    clientId: 4,
                    violationDate: getRandomDate(5),
                    amount: 100.00,
                    violationStatusId: 2,
                    violationType: 'Pet Policy',
                    communityId: 101
                },
                {
                    violationId: 5,
                    clientId: 1,
                    violationDate: getRandomDate(6),
                    amount: 300.00,
                    violationStatusId: 1,
                    violationType: 'Architectural Changes',
                    communityId: 102
                }
            ]);
        } else if (roleId === 1001 || roleId === 1002) {
            // Community roles - Community-specific violations
            setViolations([
                {
                    violationId: 1,
                    clientId: 1,
                    violationDate: getRandomDate(2),
                    amount: 150.00,
                    violationStatusId: 2,
                    violationType: 'Parking Violation'
                },
                {
                    violationId: 2,
                    clientId: 2,
                    violationDate: getRandomDate(4),
                    amount: 75.00,
                    violationStatusId: 1,
                    violationType: 'Noise Complaint'
                },
                {
                    violationId: 3,
                    clientId: 3,
                    violationDate: getRandomDate(6),
                    amount: 200.00,
                    violationStatusId: 3,
                    violationType: 'Property Maintenance'
                }
            ]);
        } else if (roleId === 1003) {
            // User - Personal violations only
            setViolations([
                {
                    violationId: 1,
                    clientId: clientIds,
                    violationDate: getRandomDate(3),
                    amount: 150.00,
                    violationStatusId: 2,
                    violationType: 'Parking Violation'
                }
            ]);
        }
    };

    const filteredViolations = violations.filter(item => {
        const violationDate = new Date(item.violationDate);
        const currentDate = new Date();

        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(currentDate.getDate() - 7);

        return violationDate >= sevenDaysAgo && violationDate <= currentDate;
    });

    const getStatusClass = (status) => {
        switch (status) {
            case 'Completed':
                return 'bg-green-100 text-green-800';
            case 'In Progress':
                return 'bg-blue-100 text-blue-800';
            case 'Cancelled':
                return 'bg-gray-100 text-gray-800';
            case 'Submitted':
                return 'bg-purple-100 text-purple-800';
            default:
                return 'bg-gray-100 text-gray-700';
        }
    };

    // Role-based title and description
    const getHeaderInfo = () => {
        switch (roleId) {
            case 1000:
                return {
                    title: "Recent Violations - System Overview",
                    description: "Showing violations from all communities in the last 7 days"
                };
            case 1001:
            case 1002:
                return {
                    title: "Recent Violations - Community",
                    description: "Showing violations from your community in the last 7 days"
                };
            case 1003:
                return {
                    title: "My Recent Violations",
                    description: "Showing your violations from the last 7 days"
                };
            default:
                return {
                    title: "Recent Violations",
                    description: "Showing violations from the last 7 days"
                };
        }
    };

    const headerInfo = getHeaderInfo();

    return (
        <div className="bg-gray-50 md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">{headerInfo.title}</h1>
                            <p className="text-sm text-gray-500">{headerInfo.description}</p>
                        </div>
                        <div className="bg-blue-50 text-blue-600 px-3 py-1 rounded-md items-center hidden md:flex">
                            <FileText size={16} className="mr-2" />
                            <span>{filteredViolations.length} violations</span>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        {roleId === 1000 && (
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Community</th>
                                        )}
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            {roleId === 1003 ? 'Violation Type' : 'Resident Name'}
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Date</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amount</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Status</th>
                                        {(roleId === 1000 || roleId === 1001 || roleId === 1002) && (
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Type</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredViolations.length === 0 ? (
                                        <tr>
                                            <td colSpan={roleId === 1000 ? "6" : "5"} className="px-6 py-8 text-center">
                                                <div className="flex flex-col items-center justify-center text-gray-500">
                                                    <AlertTriangle size={24} className="mb-2" />
                                                    <p>No violations found in the last 7 days</p>
                                                    <p className="text-sm text-gray-400 mt-1">
                                                        {roleId === 1000 ? "System-wide search" :
                                                            roleId === 1001 || roleId === 1002 ? "Community search" :
                                                                "Personal violations"}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredViolations.map((violation) => {
                                            const client = clients[violation.clientId] || {};
                                            const status = statusMap[violation.violationStatusId] || 'Unknown';
                                            return (
                                                <tr key={violation.violationId} className="hover:bg-gray-50">
                                                    {roleId === 1000 && (
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {client.communityName || `Community ${violation.communityId || 'N/A'}`}
                                                        </td>
                                                    )}
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {roleId === 1003 ?
                                                            violation.violationType || 'Violation' :
                                                            client.displayname || 'N/A'
                                                        }
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {new Date(violation.violationDate).toLocaleDateString()}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        ${violation.amount?.toFixed(2) || '0.00'}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                        <span className={`px-2 py-1 rounded-full text-xs ${getStatusClass(status)}`}>
                                                            {status}
                                                        </span>
                                                    </td>
                                                    {(roleId === 1000 || roleId === 1001 || roleId === 1002) && (
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {violation.violationType || 'General Violation'}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Summary Cards for different roles */}
                    {(roleId === 1000 || roleId === 1001 || roleId === 1002) && filteredViolations.length > 0 && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <h3 className="text-sm font-medium text-gray-600 mb-2">Total Amount</h3>
                                <p className="text-2xl font-bold text-gray-800">
                                    ${filteredViolations.reduce((sum, v) => sum + (v.amount || 0), 0).toFixed(2)}
                                </p>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <h3 className="text-sm font-medium text-gray-600 mb-2">Active Violations</h3>
                                <p className="text-2xl font-bold text-gray-800">
                                    {filteredViolations.filter(v => statusMap[v.violationStatusId] !== 'Completed').length}
                                </p>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <h3 className="text-sm font-medium text-gray-600 mb-2">Completion Rate</h3>
                                <p className="text-2xl font-bold text-gray-800">
                                    {filteredViolations.length > 0
                                        ? ((filteredViolations.filter(v => statusMap[v.violationStatusId] === 'Completed').length / filteredViolations.length) * 100).toFixed(1)
                                        : 0
                                    }%
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DashboardViolation;